import React from 'react'
import Header from '../Header'
import DetailDisplay from './DetailDisplay'

const Detail = () => {
  return (
    <React.Fragment>
      <Header />
      <DetailDisplay />
    </React.Fragment>
  )
}

export default Detail